import { render, staticRenderFns } from "./growup.vue?vue&type=template&id=4bccd124&scoped=true&"
import script from "./growup.vue?vue&type=script&lang=js&"
export * from "./growup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bccd124",
  null
  
)

export default component.exports